import type { Ref } from "vue";
import type { Requests } from "../common/request.common";
import type { AssociateMarketingResponseTypes } from "../common/response.common";
import type { SelectHook, SelectParam } from "../common/types.common";
import { asUpdateHook, buildSelectParam, get, post, postEmpty } from "./common";

export const associateMarketing = {
    record(data: typeof Requests.AssociateMarketing.Record.Input) {
        return post<typeof data, AssociateMarketingResponseTypes.Record>(
            `/associate-marketing/record`,
            data,
        );
    },
    subscriptionRecord(id: string) {
        return (data: typeof Requests.AssociateMarketing.SubscriptionRecord.Input) => {
            return post<typeof data, AssociateMarketingResponseTypes.SubscriptionRecord>(
                `/associate-marketing/subscription-record/${id}`,
                data,
            );
        };
    },
    invoiceRecord(id: string) {
        return (data: typeof Requests.AssociateMarketing.InvoiceRecord.Input) => {
            return post<typeof data, AssociateMarketingResponseTypes.InvoiceRecord>(
                `/associate-marketing/invoice-record/${id}`,
                data,
            );
        };
    },
    registrationRecord(id: string, month?: string) {
        return (data: typeof Requests.AssociateMarketing.RegistrationRecord.Input) => {
            return post<typeof data, AssociateMarketingResponseTypes.RegistrationRecord>(
                `/associate-marketing/registration-record/${id}/${month ?? ""}`,
                data,
            );
        };
    },
    create(data: typeof Requests.AssociateMarketing.Create.Input) {
        return post<typeof data>(`/associate-marketing/create`, data);
    },
    obtain(id: string) {
        return get<AssociateMarketingResponseTypes.Obtain>(`/associate-marketing/obtain/${id}`);
    },
    resetOTP(id: string) {
        return postEmpty(`/associate-marketing/reset-otp/${id}`);
    },
    formHooks: {
        select: (async (param?: SelectParam) => {
            const req = get<AssociateMarketingResponseTypes.Select>(
                `/associate-marketing/select` + buildSelectParam(param),
            );

            return (await req.execute()) ?? [];
        }) satisfies SelectHook,
        selectRegistrationPeriod(id: string) {
            return (async (param?: SelectParam) => {
                const req = get<AssociateMarketingResponseTypes.Select>(
                    `/associate-marketing/select-registration-period/${id}${buildSelectParam(param)}`,
                );

                return (await req.execute()) ?? [];
            }) satisfies SelectHook;
        },
        update(id: string, isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.AssociateMarketing.Update.Input) => {
                return await asUpdateHook(
                    post<typeof data>(`/associate-marketing/update/${id}`, data),
                    isLoading,
                );
            };
        },
    },
    dev: {
        masquerade(id: string) {
            return get<AssociateMarketingResponseTypes.Masquerade>(
                `/dev/associate-marketing/masquerade/${id}`,
            );
        },
    },
};
